"use client";
import { SnackBarData } from "../external/ensolvers-core-frontend-mui-v5/types/SnackbarData";

export const sendSnackBarMessage = (snackData: SnackBarData) => {
  const customEvent = new CustomEvent("snackMessage", {
    detail: { snackData },
  });
  document.dispatchEvent(customEvent);
};
